import type { CSSProperties, HTMLAttributes, ReactNode } from 'react';
import './Grid.css';

type GridGap = 'sm' | 'md' | 'lg' | 'xl';

export type GridProps = HTMLAttributes<HTMLDivElement> & {
    /** Minimum width (px) before a new column is allowed. */
    minItemWidth?: number;
    /** Gap token — maps to --space-* */
    gap?: GridGap;
    children: ReactNode;
};

function Grid({
    minItemWidth = 280,
    gap = 'lg',
    className = '',
    style,
    children,
    ...rest
}: GridProps) {
    const classes = ['ui-grid', `ui-grid--gap-${gap}`, className].filter(Boolean).join(' ');

    const styleWithMin: CSSProperties = {
        ...style,
        // CSS variable consumed by .ui-grid — inline so callers can override per-instance
        ['--ui-grid-min' as never]: `${minItemWidth}px`,
    };

    return (
        <div className={classes} style={styleWithMin} {...rest}>
            {children}
        </div>
    );
}

export default Grid;
